import React, { useState } from 'react';
import { InputProps } from '../helpers/types';

const InputField = ({
  state, setState, className = 'form__input', type = 'text', placeholder,
}: InputProps) => {
  const [error, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const regex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  const handleInputChange = (e: any) => {
    if (type === 'email') {
      if (!regex.test(e.target.value)) {
        setError(true);
        setErrorMessage('Please enter a valid email address');
      } else {
        setError(false);
      }
    }
    setState(e.target.value.toLowerCase());
  };

  return (
    <>
      <input
        className={`${className} ${error ? 'error' : ''}`}
        value={state}
        onChange={handleInputChange}
        type={type}
        placeholder={placeholder} />
      {error && <p className="form__error-message">{errorMessage}</p>}
    </>
  );
};

export default InputField;
